import { Component, OnInit, OnDestroy, ElementRef, HostListener } from '@angular/core'
import { Subscription } from 'rxjs'

import { User } from '../../common/interfaces/user.interface'
import { environment } from '../../../environments/environment'
import { AuthService } from '../../common/services/auth.service'
import { EventService } from '../../common/services/event.service'
import { ConnectivityService } from '../../common/services/offline/connectivity.service'
import { Role } from '../../common/enums/role.enum'

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss']
})
export class TopMenuComponent implements OnInit, OnDestroy {
  currentUser: User
  showUserMenu: boolean
  showLinkMenu: boolean
  isOnline = true

  storagePath: string = environment.storagePath
  Role = Role

  private subscriptions = new Subscription()

  constructor(
    private authService: AuthService,
    private eventService: EventService,
    private elementRef: ElementRef,
    private connectivityService: ConnectivityService
  ) {}

  ngOnInit() {
    this.authService.currentUser.subscribe((userRes: User) => {
      this.currentUser = userRes
    })

    // CLose menus on changing route
    this.eventService.routeChanged.subscribe(routeChanged => {
      this.showLinkMenu = false
      this.showUserMenu = false
    })

    this.subscriptions.add(
      this.connectivityService.isOnline$.subscribe(online => {
        this.isOnline = online
      })
    )
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
  }

  @HostListener('document:click', ['$event.target'])
  onClick(target) {
    // We track clicks to close dropdown if open and click outside
    if (
      !this.elementRef.nativeElement
        .querySelector('#create-dropdown')
        .contains(target)
    ) {
      this.showLinkMenu = false
      this.showUserMenu = false
    }
  }
}
